import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import { type BdFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues = {
  id: -1,
  status: defaultStatus,
  abbreviation: '',
  name: '',
  logo_dark: null,
  logo_light: null,
} as BdFormSchema;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/business-disciplines', name: 'Business Disciplines' },
];
